/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

const moduleName = 'licensing';
const componentName = 'disconnect-cloud-licensing-modal';
const prefix = `${moduleName}.${componentName}`;

export const disconnectFromCloudLicensingHeader = `${prefix}.disconnectFromCloudLicensingHeader`;
export const disconnectConfirmationMessage = `${prefix}.disconnectConfirmationMessage`;
export const disconnectFromCloudServicesLabel = `${prefix}.disconnectFromCloudServicesLabel`;
export const cancelButtonLabel = `${prefix}.cancelButtonLabel`;
export const yesContinueButtonLabel = `${prefix}.yesContinueButtonLabel`;

export const ENGLISH = {
    [disconnectFromCloudLicensingHeader]: 'Disconnect from Cloud Licensing',
    [disconnectConfirmationMessage]: 'Are you sure you want to disconnect from Cloud Licensing?',
    [disconnectFromCloudServicesLabel]: 'I want to also disconnect from Cloud Services.',
    [cancelButtonLabel]: 'CANCEL',
    [yesContinueButtonLabel]: 'YES, CONTINUE',
};
